import React from "react";
import ConfigContext from "../context/ConfigContext";

export const useConfig = () => React.useContext(ConfigContext);
